module.exports = __webpack_public_path__ + "static/media/pending.1166f5da.png";